'use client';

import { fetchMemberFind } from '@module/apis/client-side/member';
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import useModalStore from '@module/stores/useModalStore';
import { MODAL_TYPE_PC } from '@module/types/modal/type';
import catchAllErrors from '@module/utils/catchAllErrors';
import { BaseHttpResponseError } from '@module/utils/error/apiErrors';
import RouteTabs from '@pc/components/molecules/tab/RouteTabs';
import RouteTabsItem from '@pc/components/molecules/tab/RouteTabsItem';
import BaseStep from '@pc/components/step/BaseStep';
import BaseStepItem from '@pc/components/step/BaseStepItem';
import { useRouter, useSearchParams } from 'next/navigation';
import { Suspense, useState } from 'react';
import IdentityVerificationStepOnUserFind from './IdentityVerificationStepOnUserFind';
import IdListContainer from './id/IdListContainer';
import CheckIdContainter from './pw/CheckIdContainter';
import NewPasswordContainer from './pw/NewPasswordContainer';
function UserFindContainer() {
  const searchParams = useSearchParams();
  const type = searchParams.get('type') || 'id';
  const {
    isLogin
  } = useGetLoginInfoQuery();
  const router = useRouter();
  const {
    pushModal,
    popModal
  } = useModalStore();
  const [idStep, setIdStep] = useState(0);
  const [pwStep, setPwStep] = useState(0);
  const [sessKey, setSessKey] = useState('');
  const [pwTargetId, setPwTargetId] = useState('');
  const goIdNextStep = () => {
    setIdStep(prevState => {
      return prevState + 1;
    });
  };
  const goPwNextStep = () => {
    setPwStep(prevState_0 => {
      return prevState_0 + 1;
    });
  };
  const resetProcess = () => {
    setIdStep(0);
    setPwStep(0);
    setSessKey('');
    setPwTargetId('');
  };
  const handleIdVerificationSuccess = (sessKey_0: string) => {
    setSessKey(sessKey_0);
    goIdNextStep();
  };
  const handlePwVerificationSuccess = async (sessKey_1: string) => {
    setSessKey(sessKey_1);
    try {
      await fetchMemberFind({
        session: sessKey_1,
        findId: pwTargetId
      });
      goPwNextStep();
    } catch (err) {
      if (err instanceof BaseHttpResponseError) {
        catchAllErrors(err.message, () => {
          pushModal({
            type: MODAL_TYPE_PC.CONFIRM_MODAL,
            id: 'UserFindContainer',
            options: {
              description: err.message,
              onClose: () => {
                resetProcess();
                popModal();
              }
            }
          });
        });
      }
    }
  };
  if (isLogin) {
    router.push('/');
  }
  return <div data-testid='user-find-page' className='contents'>
      <Suspense>
        <RouteTabs className='mt-5 mb-10' contentClassName='w-full'>
          <RouteTabsItem path='/user/find' subPath='?type=id' onClick={() => {
          setIdStep(0);
        }} disableActiveStyle={type !== 'id'}>
            아이디 찾기
          </RouteTabsItem>
          <RouteTabsItem path='/user/find' subPath='?type=pw' onClick={() => {
          setPwStep(0);
        }} disableActiveStyle={type !== 'pw'}>
            비밀번호 찾기
          </RouteTabsItem>
        </RouteTabs>
      </Suspense>
      {type === 'id' && <BaseStep step={idStep} stepList={['본인 인증', '아이디 확인']}>
          <BaseStepItem value='본인 인증'>
            <IdentityVerificationStepOnUserFind onVerificationSuccess={handleIdVerificationSuccess} />
          </BaseStepItem>
          <BaseStepItem value='아이디 확인'>
            <IdListContainer sessKey={sessKey} setPwStep={setPwStep} setPwTargetId={setPwTargetId} />
          </BaseStepItem>
        </BaseStep>}
      {type === 'pw' && <BaseStep step={pwStep} stepList={['아이디 확인', '본인 인증', '비밀번호 설정']}>
          <BaseStepItem value='아이디 확인'>
            <CheckIdContainter goNextStep={goPwNextStep} setPwTargetId={setPwTargetId} />
          </BaseStepItem>
          <BaseStepItem value='본인 인증'>
            <IdentityVerificationStepOnUserFind onVerificationSuccess={handlePwVerificationSuccess} />
          </BaseStepItem>
          <BaseStepItem value='비밀번호 설정'>
            <NewPasswordContainer sessKey={sessKey} pwTargetId={pwTargetId} />
          </BaseStepItem>
        </BaseStep>}
    </div>;
}
export default UserFindContainer;